import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {FlowDetail, TemporalParameter} from "@app/netscope/model/data-models";
import {NetscopeUtils} from "@app/netscope/netscope-utils";
import {FlowsRepository} from "@app/netscope/model/flows-repository";

export class TransportProtocolDetail {
  protoNumber: number;
  protoLabel: string;
}

export class PortDetail {
  direction: number;
  label: string;
  transport_protocols: TransportProtocolDetail[];
  protocols: string[];
  exchanged_bytes: number;
  exchanged_packets: number;
}


@Component({
  standalone: false,
  selector: 'app-expandable-rows',
  templateUrl: './expandable-rows.component.html',
  styleUrls: ['./expandable-rows.component.css']
})
export class ExpandableRowsComponent implements OnInit {

  @Input() flowDetail: FlowDetail;
  @Input() flowsRepository: FlowsRepository;
  @Input() temporalParameter: TemporalParameter;
  @Input() bidirectional = false;
  loading: boolean;

  ports: PortDetail[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.loading = true;

    this.flowsRepository.getFlowsMetrics(this.flowDetail.source.uuid, this.flowDetail.target.uuid).then((flowsWithPorts) => {
      this.ports = [];
      for (let flowDetail of flowsWithPorts) {
        for (let [portNumber, m] of flowDetail.metrics.entries()) {
          this.ports.push({
            direction: m.direction,
            label: `${portNumber}`,
            transport_protocols: NetscopeUtils.trasnsportProtocolRawStringToObject(m.transport_protocols),
            protocols: [m.application_protocol],
            exchanged_bytes: m.exchanged_bytes,
            exchanged_packets: m.exchanged_packets
          });
        }
      }
      setTimeout(() => {
        this.loading = false;
      });
    });
  }

  protected readonly NetscopeUtils = NetscopeUtils;
}

